import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getBurgerMenuHeight } from '../BurgerMenu';
export default function SlideoutMenuPanel(props) {
    return (_jsx(StyledSlideoutMenuPanel, { children: _jsx(StyledSlideoutContent, { className: "slideout-content", children: props.content }) }));
}
const StyledSlideoutMenuPanel = styled.section `
	position: fixed;
	width: ${(props) => props.theme.sizing.xl};
	overflow: hidden;
	min-height: 100vh;
	max-height: 100vh;
	display: flex;
	flex-direction: row;

	height: 100%;
	top: 0;
	left: 0;

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		top: ${(props) => getBurgerMenuHeight(props.theme)};
		left: 0;
		min-height: calc(100vh - ${(props) => getBurgerMenuHeight(props.theme)});
		max-height: calc(100vh - ${(props) => getBurgerMenuHeight(props.theme)});
	}
`;
const StyledSlideoutContent = styled.section `
	overflow: auto;
	background-color: ${(props) => props.theme.palette.shade7};
	padding: ${(props) => props.theme.spacing.md};
	background-color: ${(props) => props.theme.palette.primary};
	width: ${(props) => props.theme.sizing.xl};

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		width: 100%;
	}
`;
//# sourceMappingURL=SlideoutMenuPanel.js.map